import React from 'react';
import ConnectedSegments from '../ConnectedSegments';
import ConnectedSegmentTags from '../ConnectedSegmentTags';
import ErrorBoundary from '../../../common/ErrorBoundary';
import PropTypes from 'prop-types';
function SegmentsAndTags({ isResearcher }) {
    return (
        <div className="content-box p-0">
            <div className="row">
                {isResearcher && (
                    <div className="col-5">
                        <ErrorBoundary>
                            <ConnectedSegments isResearcher={isResearcher} />
                        </ErrorBoundary>
                    </div>
                )}
                <div className="col-7">
                    <ErrorBoundary>
                        <ConnectedSegmentTags />
                    </ErrorBoundary>
                </div>
            </div>
        </div>
    );
}
SegmentsAndTags.propTypes = {
    isResearcher: PropTypes.bool,
};
export default SegmentsAndTags;
